import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TaskAttachment } from '@shared/services/monthly-task.service';

@Component({
    selector: 'app-attachment-item',
    template: `
    <div class="d-flex align-items-center justify-content-between file-list-item w-100 small text-muted"
        style="font-size: 0.95rem;">
        
        <!-- Date (Left) -->
        <span class="flex-shrink-0 text-muted">{{ attachment.uploadedAt | date:'yyyy-MM-dd' }}</span>

        <!-- Right Side Group -->
        <div class="d-flex align-items-center text-truncate justify-content-end" style="min-width: 0;">
            <i class="ft-file-text me-1 text-primary flex-shrink-0"></i>
            
            <!-- Filename -->
            <span class="text-truncate fw-bold text-primary me-1"
                style="cursor: pointer; text-decoration: underline;" 
                (click)="onFilenameClick()"
                title="{{ attachment.originalName }}">
                {{ attachment.originalName }}
            </span>

            <!-- Size -->
            <span class="flex-shrink-0 text-muted" style="margin-right: 30px;">({{ attachment.size | fileSize }})</span>

            <!-- Download Button -->
            <button type="button" class="btn btn-sm btn-outline-secondary flex-shrink-0 me-1" title="Download"
                (click)="onDownload()">
                <i class="ft-download"></i>
            </button>

            <!-- Delete Button -->
            <button type="button" class="btn btn-sm btn-outline-danger flex-shrink-0" title="Delete File"
                *ngIf="showDelete"
                (click)="onDelete()">
                <i class="ft-trash-2"></i>
            </button>

             <!-- Restore Button -->
             <button type="button" class="btn btn-sm btn-outline-success flex-shrink-0" title="Restore File"
                *ngIf="showRestore"
                (click)="onRestore()">
                <i class="ft-rotate-ccw"></i>
            </button>
        </div>
    </div>
  `,
    styles: [`
    .file-list-item {
        /* Optional styling */
    }
  `]
})
export class AttachmentItemComponent {
    @Input() attachment!: TaskAttachment;
    @Input() showDelete = false;
    @Input() showRestore = false;

    @Output() download = new EventEmitter<TaskAttachment>();
    @Output() preview = new EventEmitter<TaskAttachment>();
    @Output() delete = new EventEmitter<TaskAttachment>();
    @Output() restore = new EventEmitter<TaskAttachment>();

    private readonly PREVIEW_REGEX = /\.(pdf|txt|json|xml|md|png|jpe?g|gif|webp|svg|bmp|ico)$/i;

    canPreview(filename: string): boolean {
        return !!filename && this.PREVIEW_REGEX.test(filename);
    }

    onFilenameClick() {
        if (this.canPreview(this.attachment.originalName)) {
            this.onPreview();
        } else {
            this.onDownload();
        }
    }

    onDownload() {
        this.download.emit(this.attachment);
    }

    onPreview() {
        this.preview.emit(this.attachment);
    }

    onDelete() {
        this.delete.emit(this.attachment);
    }

    onRestore() {
        this.restore.emit(this.attachment);
    }
}
